import { memo, useMemo } from 'react';

import Tippy from '@tippyjs/react';

import { getTimezoneLabel } from '../lib/getTimezoneLabel';

const Timezone = ({ value, isTimezone, timezone, date }) => {
  const { label, tooltip } = useMemo(
    () => ({
      label: getTimezoneLabel(value, isTimezone, timezone, 'zzz', date),
      tooltip: getTimezoneLabel(value, isTimezone, timezone, 'zzzz', date)
    }),
    [value, isTimezone, timezone, date]
  );

  if (!label) return null;

  return (
    <Tippy content={tooltip} className="tippy-dark">
      <span
        tabIndex={0}
        className="select-none whitespace-nowrap rounded-sm text-xs font-500 text-neutral-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-primary-200">
        {label}
      </span>
    </Tippy>
  );
};

export default memo(Timezone);
